import { createFileRoute } from '@tanstack/react-router'
import ConceptPreliminaryEdition from 'Concept/components/Concept/Sections/ConceptPreliminaryEdition/ConceptPreliminaryEdition'

import { Guard } from '../../../-guard'

export const Route = createFileRoute('/concept/$conceptId/productions/$productionId')({
    component: () => (
        <Guard notFeatures={['profitability']}>
            <ConceptPreliminaryEdition />
        </Guard>
    ),
})
